import { css } from 'styled-components';
import ScissorClosedSvg from 'assets/svgs/scissor_closed.svg';
import ScissorOpenSvg from 'assets/svgs/scissor_open.svg';

export const SplitModeStyles = css`
  .b-sch-event {
    .splitter {
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      width: 16px;
      transform: translateX(-8px);
      overflow: visible;
      .white-bar {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 6px;
        border-right: 2px dashed white;
        z-index: 1;
        pointer-events: none;

        &:before,
        &:after {
          position: absolute;
          height: 7px;
          width: 14px;
          background: radial-gradient(
              circle 6px at left bottom,
              transparent 6px,
              var(--blue-10) 0
            ),
            radial-gradient(
              circle 6px at right bottom,
              transparent 6px,
              var(--blue-10) 0
            );
          background-size: 7px, 7px;
          background-position: left, right;
          background-repeat: no-repeat, no-repeat;
          z-index: 2;
          left: -6px;
        }
        &:before {
          top: -1px;
        }
        &:after {
          transform: rotate(180deg);
          bottom: -1px;
        }
      }
      &:hover {
        cursor: url(${ScissorClosedSvg}) 12 0, auto;
        .white-bar {
          &:before,
          &:after {
            content: '';
          }
        }
      }
    }
    &.splitMode {
      cursor: url(${ScissorOpenSvg}) 12 0, auto;
    }
  }
`;
